module.exports = __webpack_public_path__ + "static/img/other-wenziti.d3d90199.png";